import React from "react";
import { Span, SpanProps } from "../..";
import { styled, EmotionComponent } from "../../styled";

export type TruncateProps = {
  /**  specifies the number of lines for a multiline truncation. If not present, will use single line solution. */
  lines?: number;
} & SpanProps;

type TruncateMultilineProps = { lines?: number } & SpanProps;

const TruncateMultiline: EmotionComponent<TruncateMultilineProps> = styled(
  Span
)<TruncateMultilineProps>`
  display: -webkit-box;
  -webkit-line-clamp: ${(props) => props.lines};
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const TruncateSingleLine: EmotionComponent<SpanProps> = styled(Span)`
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const Truncate: React.FC<TruncateProps> = ({
  lines,
  children,
  ...spanProps
}) => {
  return lines ? (
    <TruncateMultiline lines={lines} {...spanProps}>
      {children}
    </TruncateMultiline>
  ) : (
    <TruncateSingleLine {...spanProps}>{children}</TruncateSingleLine>
  );
};

Truncate.displayName = "Truncate";

export default Truncate;
